import { setSiteLanguageChoice } from '@util/language-preferences';

export default class ToolMenu {
  readonly dropdownButtons: NodeListOf<HTMLButtonElement>;
  readonly languageLinks: NodeListOf<Element>;
  isOpen: boolean;

  constructor() {
    this.dropdownButtons = document.querySelectorAll('.tool-menu__item--has-dropdown > .tool-menu__link') as NodeListOf<HTMLButtonElement>;
    this.languageLinks = document.querySelectorAll(".language-menu__link");
    this.isOpen = false;

    this.init();
  }

  private init(): void {
    if (this.dropdownButtons.length > 0) {
      this.dropdownButtons.forEach(button => {
        button.addEventListener('click', (): void => {
          this.toggleDropdown(button);
        });
      });

      document.addEventListener('click', (event: MouseEvent): void => {
        if (!this.isOpen) {
          return;
        }

        this.closeOnOutsideClick(event);
      });
    }

    if (!!this.languageLinks) {
      this.languageLinks.forEach(link => {
        link.addEventListener('click', (e: Event) => {
          e.preventDefault();
          const language = (link as HTMLAnchorElement).dataset.siteLanguage;
          if (language) setSiteLanguageChoice(language);
          if (document.body.classList.contains('audio-guide-page')) {
            const destination = new URL((link as HTMLAnchorElement).href);
            destination.search = window.location.search;
            destination.hash = window.location.hash;
            if (document.querySelector('.audio-guide-language-selector')) {
              // Keep an open selector and the station/listing it was opened from.
              const [path, query = ''] = destination.hash.slice(1).split('?', 2);
              const parameters = new URLSearchParams(query);
              parameters.set('chooseLanguage', '1');
              destination.hash = `${path || '/'}?${parameters.toString()}`;
            }
            window.location.href = destination.href;
          } else {
            window.location.href = (link as HTMLAnchorElement).href + window.location.search;
          }
        });
      });
    }
  }

  private toggleDropdown(button: HTMLButtonElement): void {
    const dropdown = button.nextElementSibling as HTMLDivElement;

    if (!dropdown.classList.contains('tool-menu__dropdown--open')) {
      this.closeAllDropdowns();
      this.openDropdown(button, dropdown);
    } else {
      this.closeDropdown(button, dropdown);
    }
  }

  private openDropdown(button: HTMLButtonElement, dropdown: HTMLDivElement): void {
    dropdown.classList.add('tool-menu__dropdown--open');
    button.classList.add('tool-menu__link--expanded');
    button.setAttribute('aria-expanded', 'true');
    this.isOpen = true;
  }

  private closeDropdown(button: HTMLButtonElement, dropdown: HTMLDivElement): void {
    dropdown.classList.remove('tool-menu__dropdown--open');
    button.classList.remove('tool-menu__link--expanded');
    button.setAttribute('aria-expanded', 'false');
    this.isOpen = false;
  }

  private closeAllDropdowns(): void {
    this.dropdownButtons.forEach(button => {
      const dropdown = button.nextElementSibling as HTMLDivElement | null;

      if (dropdown?.classList.contains('tool-menu__dropdown--open')) {
        this.closeDropdown(button, dropdown);
      }
    });

    this.isOpen = false;
  }

  private closeOnOutsideClick(event: MouseEvent): void {
    const target = event.target;

    if (!(target instanceof Node)) {
      return;
    }

    this.dropdownButtons.forEach(button => {
      const container = button.closest('.tool-menu__item--has-dropdown');
      const dropdown = button.nextElementSibling as HTMLDivElement | null;

      if (!container || !dropdown?.classList.contains('tool-menu__dropdown--open')) {
        return;
      }

      if (!container.contains(target)) {
        this.closeDropdown(button, dropdown);
      }
    });
  }
}
